module.exports = __webpack_public_path__ + "static/media/icon-time.59142acb.svg";